import React from "react";
import PostalEntry from "../PostalEntry/PostalEntry";
import useTickets from "../../hooks/useTickets";
import useAgeVerification from "../../hooks/useAgeVerification";
import AgeVerificationPopup from "../common/AgeVerificationPopup";
import SubscriptionCard from "../SubscriptionCard/SubscriptionCard";

import "./styles.css";

const SubscriptionList = (props) => {
  const {
    prizeId,
    raffles,
    isExpired,
    subscriptionModels,
    theme = "light",
  } = props;
  const { loading, activeSubscription, addSubscriptionToBasket } = useTickets({
    prizeId,
    isDouble: raffles.length > 1,
  });
  const { showAgePopup, requireAgeVerification, confirmAge, closeAgePopup } =
    useAgeVerification();

  const handleAddSubscription = (sub, temporaryDiscount) => () => {
    requireAgeVerification(() =>
      addSubscriptionToBasket(sub, temporaryDiscount)(),
    );
  };

  return (
    <div className="ticket-container">
      <div className="ticket-list ticket-list--subscription">
        <>
          {subscriptionModels && subscriptionModels.length
            ? subscriptionModels.map((sub, index) => {
                return (
                  <SubscriptionCard
                    key={index}
                    index={index}
                    type={"win"}
                    raffles={raffles}
                    loading={loading}
                    sub={sub}
                    pricePerMonth={`£${sub.totalCost / 100}`}
                    ticket={{ tickets: sub.numOfTickets + sub.extra }}
                    theme={theme}
                    activeSubscription={activeSubscription}
                    isExpired={isExpired}
                    addSub={handleAddSubscription}
                  />
                );
              })
            : null}
        </>
      </div>
        <div className="postal-entry">
          <PostalEntry loading={loading} theme={theme} is341={true} />
        </div>
      {showAgePopup && (
        <AgeVerificationPopup onConfirm={confirmAge} onClose={closeAgePopup} />
      )}
    </div>
  );
};

export default SubscriptionList;
